import React, { useMemo, useState } from 'react';

// @ts-ignore
import Tab from '@r1-frontend/ui-react/components/tabs/tab';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import AdvantagesBlock from '~/src/components/BlockInternet/AdvantagesBlock';
import {
    countryHouseInternetData,
    homeInternetData,
    homeInternetTabs,
    villageInternetData,
} from '~/src/components/BlockInternet/constants';
import { EPrivateHouse } from '~/src/features/internet/internet-represent';
import { useOptimizationToponymForInternetPage } from '~/src/helpers/city/useOptimizationToponym';

import * as ST from './styled';

interface IProps{
    privateHouse?: EPrivateHouse,
}

const tabStyles = (label: string, activeTabLabel: string) => ({
    label,
    margin: '0 0 6px 0',
    style: {
        fontWeight: 'normal',
        margin: 0,
        ...(label === activeTabLabel ? { color: COLORS.TextWhite, backgroundColor: COLORS.ButtonPrimary } : {}),
    },
});

const HomeInternet = ({ privateHouse }: IProps) => {
    const toponymOptimization  = useOptimizationToponymForInternetPage();

    const isVillage = privateHouse === EPrivateHouse.Village;
    const isCountryHouse = privateHouse === EPrivateHouse.CountryHouse;
    const [activeTab, setActiveTab] = useState(
        isVillage
            ? homeInternetTabs.house
            : isCountryHouse
                ? homeInternetTabs.countryHouse
                : homeInternetTabs.apartment,
    );
    const tabs = useMemo(() => {
        const apartment = <Tab {...tabStyles(homeInternetTabs.apartment, activeTab)} key={'apartment'}>
            <AdvantagesBlock incomingData={homeInternetData} />
        </Tab>;
        const house = <Tab {...tabStyles(homeInternetTabs.house, activeTab)} key={'house'}>
            <AdvantagesBlock incomingData={villageInternetData}/>
        </Tab>;
        const countryHouse = <Tab {...tabStyles(homeInternetTabs.countryHouse, activeTab)} key={'countryHouse'}>
            <AdvantagesBlock incomingData={countryHouseInternetData}/>
        </Tab>;
        if (isVillage) {
            return [house, countryHouse, apartment];
        } else if (isCountryHouse) {
            return [countryHouse, house, apartment];
        } else {
            return [apartment, house, countryHouse];
        }
    }, [activeTab, isVillage, isCountryHouse]);

    return (
        <ST.HomeInternetContainer>
            <ST.HomeInternetTitle>
                {isVillage
                    ? 'Преимущества интернета в частном доме от Дом.ру:'
                    : isCountryHouse
                        ? 'Преимущества интернета на даче от Дом.ру:'
                        : `Преимущества домашнего интернета от Дом.ру${toponymOptimization || ''}:`
                }
            </ST.HomeInternetTitle>
            <ST.STabs activeTab={activeTab} onSwitchTab={setActiveTab} data-test='tabs'>
                {tabs}
            </ST.STabs>
        </ST.HomeInternetContainer>
    );
};

export default HomeInternet;
